import { Routes, Route, Navigate } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import { Box } from '@mui/material'
import { LoadingSkeleton } from './components/common/LoadingSkeleton'

// Lazy load page components
const LoginPage = lazy(() => import('./components/auth/LoginPage'))
const ProtectedRoute = lazy(() => import('./components/auth/ProtectedRoute'))
const DashboardLayout = lazy(() => import('./pages/DashboardLayout'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const UsersPage = lazy(() => import('./pages/UsersPage'))
const CompaniesPage = lazy(() => import('./pages/CompaniesPage'))
const Reports = lazy(() => import('./pages/Reports'))
const Settings = lazy(() => import('./pages/Settings'))
const NotFound = lazy(() => import('./pages/NotFound'))

// Loading component
const PageLoader = () => (
  <Box sx={{ p: 3 }}>
    <LoadingSkeleton variant="pageHeader" />
  </Box>
)

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Auth routes */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* Protected dashboard routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users/*" element={
            <ProtectedRoute requireUserManager>
              <UsersPage />
            </ProtectedRoute>
          } />
          <Route path="companies/*" element={
            <ProtectedRoute requireCompanyManager>
              <CompaniesPage />
            </ProtectedRoute>
          } />
          <Route path="reports/*" element={
            <ProtectedRoute requiredPermissions={['reports:user_activity', 'reports:company_usage']}>
              <Reports />
            </ProtectedRoute>
          } />
          <Route path="settings" element={
            <ProtectedRoute requireAdmin>
              <Settings />
            </ProtectedRoute>
          } />
        </Route>
        
        {/* Catch all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}

export default App